import React from 'react';
import { useTheme } from '@mui/material';
import { useAtomValue } from 'jotai';
import DoneOutlineSharpIcon from '@mui/icons-material/DoneOutlineSharp';
import { ColumnFlexBox, FullSizeFlexBox } from '../../../../Components/FlexBox';
import DataBox from '../../../Dashboard/DataBox';
import ResultCallWidget from '../../../Dashboard/Widgets/ResultCallWidget';
import SectionsCallsWidget from '../../../Dashboard/Widgets/SectionsCallsWidget';
import OutcomeCallsWidget from '../../../Dashboard/Widgets/OutcomeCallsWidget';
import { allOutcomesAtom } from '../../../../Atoms';
import { ICONS } from '../../../../Utils/constants/icons';
import { useIntl } from 'react-intl';

const SectionCountersRow = function SectionCountersRow({
  title,
  totalCount,
  answeredCount,
  unansweredCount,
  target,
  outcomeCounters,
}) {
  const intl = useIntl();
  const theme = useTheme();
  const allOutcomes = useAtomValue(allOutcomesAtom);
  const IconComponent = target ? DoneOutlineSharpIcon : ICONS[title];

  return (
    <FullSizeFlexBox gap="16px">
      <ColumnFlexBox gap="16px" width="40%">
        <DataBox
          title={intl.messages[title?.toUpperCase()] ?? title}
          icon={IconComponent ? <IconComponent /> : null}
          color={theme.custom.stringToColor(title || '')}
          widget={
            <SectionsCallsWidget
              performedCalls={totalCount}
              performedOnTargetCalls={answeredCount}
              target={target}
              hideGap
            />
          }
        />
        <DataBox
          widget={
            <ResultCallWidget
              hideTooltip
              answeredCount={answeredCount}
              notAnsweredCount={unansweredCount}
              answered={
                (answeredCount / (answeredCount + unansweredCount)) * 100
              }
              notAnswered={
                (unansweredCount / (answeredCount + unansweredCount)) * 100
              }
            />
          }
        />
      </ColumnFlexBox>
      <DataBox
        centered
        widget={
          <OutcomeCallsWidget
            sectionName={intl.messages[title?.toUpperCase()] ?? title}
            total={totalCount}
            data={outcomeCounters?.map(({ name, count }) => ({
              outCome: allOutcomes?.find(
                (o) => o?.name?.toUpperCase() === name?.toUpperCase()
              )?.id,
              name,
              performedCalls: count,
            }))}
          />
        }
      />
    </FullSizeFlexBox>
  );
};

export default SectionCountersRow;
